import {createGetAllMethod, createPutMethod,} from "../core/factory";
import {entityType} from "./module";

export const getAllSystemSettings = () => createGetAllMethod(entityType)
export const updateSystemSetting = (payload) => createPutMethod(entityType, payload)
